import { render, staticRenderFns } from "./indexClassify.vue?vue&type=template&id=6740202a&scoped=true&"
import script from "./indexClassify.vue?vue&type=script&lang=js&"
export * from "./indexClassify.vue?vue&type=script&lang=js&"
import style0 from "./indexClassify.vue?vue&type=style&index=0&id=6740202a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740202a",
  null
  
)

export default component.exports